import { useEffect, useState } from "react";
import { Link as RouterLink, useNavigate, useSearchParams } from "react-router";
import {
    Alert, Box, Button, Card, FormControl, FormLabel, IconButton, Input, Link,
    Stack, Typography,
} from "@mui/joy";
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

import { APIPartnerResetPassword } from "../../api_partner_auth";
import { NAME_PROJECT } from "../../utils";


export default function PartnerResetPasswordPage() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get('token') || '';

    const [pw, setPw] = useState('');
    const [pw2, setPw2] = useState('');
    const [showPw, setShowPw] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [done, setDone] = useState(false);

    useEffect(() => {
        if (!token) setError('В ссылке отсутствует токен');
    }, [token]);

    const submit = async () => {
        setError(null);
        if (pw.length < 8) { setError('Пароль должен быть не короче 8 символов'); return; }
        if (pw !== pw2) { setError('Пароли не совпадают'); return; }
        try {
            setLoading(true);
            await APIPartnerResetPassword({ token, new_password: pw });
            setDone(true);
        } catch (e) {
            setError(e?.response?.data?.error || 'Не удалось сбросить пароль');
        } finally { setLoading(false); }
    };

    return (
        <Box sx={{
            minHeight: '100vh',
            display: 'flex', flexDirection: 'column',
            justifyContent: 'center', alignItems: 'center',
            px: 2, py: 4,
            background: (theme) => `linear-gradient(145deg, ${theme.vars.palette.primary[50]} 0%, #ffffff 100%)`,
        }}>
            <Stack direction="column" alignItems="center" spacing={1} sx={{ mb: 3 }}>
                <Typography level="h3" sx={{ fontWeight: 'bold', color: 'primary.700' }}>Кабинет партнёра</Typography>
                <Typography level="body-sm" color="neutral">{NAME_PROJECT}</Typography>
            </Stack>

            <Card sx={{ width: '100%', maxWidth: 420, p: 3, borderRadius: 'xl', boxShadow: 'lg' }}>
                <Typography level="title-lg" sx={{ mb: 0.5 }}>Новый пароль</Typography>

                {done ? (
                    <>
                        <Alert color="success" variant="soft" startDecorator={<CheckCircleRoundedIcon />} sx={{ mt: 1, mb: 2 }}>
                            Пароль успешно обновлён.
                        </Alert>
                        <Button fullWidth onClick={() => navigate('/partner/login')}>Войти</Button>
                    </>
                ) : (
                    <>
                        {error && <Alert color="danger" sx={{ mb: 1.5 }}>{error}</Alert>}
                        <Stack spacing={1.5}>
                            <FormControl>
                                <FormLabel>Новый пароль</FormLabel>
                                <Input
                                    type={showPw ? 'text' : 'password'}
                                    startDecorator={<LockRoundedIcon />}
                                    endDecorator={
                                        <IconButton variant="plain" size="sm" onClick={() => setShowPw(s => !s)}>
                                            {showPw ? <VisibilityOffRoundedIcon /> : <VisibilityRoundedIcon />}
                                        </IconButton>
                                    }
                                    value={pw}
                                    onChange={e => setPw(e.target.value)}
                                    placeholder="не короче 8 символов"
                                    disabled={!token}
                                />
                            </FormControl>
                            <FormControl>
                                <FormLabel>Повторите пароль</FormLabel>
                                <Input
                                    type={showPw ? 'text' : 'password'}
                                    startDecorator={<LockRoundedIcon />}
                                    value={pw2}
                                    onChange={e => setPw2(e.target.value)}
                                    disabled={!token}
                                    onKeyDown={e => e.key === 'Enter' && submit()}
                                />
                            </FormControl>
                            <Button onClick={submit} loading={loading} size="lg" disabled={!token}>
                                Сохранить пароль
                            </Button>
                        </Stack>
                    </>
                )}

                <Box sx={{ mt: 2, textAlign: 'center' }}>
                    <Link component={RouterLink} to="/partner/login" level="body-sm">
                        Вернуться к входу
                    </Link>
                </Box>
            </Card>
        </Box>
    );
}